import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Company } from '../../../entities/company/types';

interface CompanyState {
  currentCompanyId: string | null;
  companies: Record<string, Company>;
}

const initialState: CompanyState = {
  currentCompanyId: null,
  companies: {},
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCurrentCompany: (state, action: PayloadAction<string>) => {
      state.currentCompanyId = action.payload;
    },
    addCompany: (state, action: PayloadAction<Company>) => {
      state.companies[action.payload.id] = action.payload;
    },
    updateCompany: (state, action: PayloadAction<Company>) => {
      if (action.payload.id in state.companies) {
        state.companies[action.payload.id] = action.payload;
      }
    },
    removeCompany: (state, action: PayloadAction<string>) => {
      delete state.companies[action.payload];
      if (state.currentCompanyId === action.payload) {
        state.currentCompanyId = null;
      }
    },
  },
});

export const { setCurrentCompany, addCompany, updateCompany, removeCompany } = companySlice.actions;
export default companySlice.reducer;